import styled from "styled-components";

export const DraftsWrap = styled.div`
  display: flex;
  color: blue;
  padding: 20px;
`;
